export default __webpack_public_path__ + "static/media/RemindMe.ebb6e8b0.png";